import { Injectable } from '@angular/core';
import { CompanyParam } from "./models/company-param";

@Injectable({
    providedIn: 'root'
})
export class DashboardDataCacheService {
    companyParams: CompanyParam[] = [];

    /**
     * Realiza la obtención de los parametros que no existan en la cache
     * @param model Identificadores de la compañía
     * @returns
     */
    getCompanyParamsExist(model: CompanyParam[]): CompanyParam[] {
        if (this.companyParams.length != 0) {
            let params: CompanyParam[] = [];

            for (let index = 0; index < model.length; index++) {
                let exist = this.companyParams.filter(x => { return x.CompanyId == model[index].CompanyId && x.ParamId == model[index].ParamId });
                if (exist.length == 0) {
                    params.push(model[index]);
                }
            }

            return params;
        }

        return model;
    }

    /**
     * Retorna los parametros que se han almacenado en la cache
     * @param model Identificadores de la compañía
     * @returns las compañias
     */
    getCompanyParams(model: CompanyParam[]): CompanyParam[] {
        if (this.companyParams.length != 0) {
            let params = [];

            for (let index = 0; index < model.length; index++) {
                let exist = this.companyParams.filter(x => { return x.CompanyId == model[index].CompanyId && x.ParamId == model[index].ParamId });
                if (exist.length > 0) {
                    params.push(exist[0]);
                }
            }

            return params;
        }

        return [];
    }

    /**
     * Almacena los parametros de compañias
     * @param companyParamsCall Datos de las compañias
     */
    setCompanyParams(companyParamsCall: CompanyParam[]) {
        this.companyParams = this.companyParams.concat(companyParamsCall);
    }
}